module.exports = __webpack_public_path__ + "static/banner-footer-update-data-pe-f96ea35e0c98ba90f8a707c17e927723.png";